import * as React from 'react';
import { Popover as PopoverMui } from '@mui/material';
import { Text } from './text';

interface Props {
  id?: string;
  value?: string;
  anchorEl: HTMLElement | null,  
  children?: React.ReactNode;
}

export const Popover: React.FunctionComponent<Props> = (props) => {
  return (
    <PopoverMui 
      id={props.id}
      open={!!props.anchorEl}
      anchorEl={props.anchorEl}
      anchorOrigin={{ vertical: 'center', horizontal: 'right'}}
      transformOrigin={{ vertical: 'center', horizontal: 'left'}}
      sx={{ pointerEvents: 'none', marginLeft: 1}}
      disableRestoreFocus
    >
      <Text label={props.value} sx={{bgcolor:'white', borderShadow: 1, padding: 1}} />
      {props.children}
    </PopoverMui>
  );
}
